import { render, staticRenderFns } from "./krahung.vue?vue&type=template&id=63fafbd6"
import script from "./krahung.vue?vue&type=script&lang=js"
export * from "./krahung.vue?vue&type=script&lang=js"
import style0 from "./krahung.vue?vue&type=style&index=0&id=63fafbd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports